<template>
	<div>
<!--		Sample Blob {{config.Settings.SampleBlob}}-->
<!--		Sample Storage {{config.Settings.SampleContainer}}-->
<!--		<div v-if="syncStatus">-->
<!--		DB Sync {{syncStatus.current}}-->
<!--		<table>-->
<!--			<thead>-->
<!--				<tr>-->
<!--					<th>Object</th>-->
<!--					<th>Missing</th>-->
<!--					<th>Differences</th>-->
<!--				</tr>-->
<!--			</thead>-->
<!--			<tbody>-->
<!--				<tr>-->
<!--					<td>Applications</td>-->
<!--					<td>{{syncStatus.applications.missing}}</td>-->
<!--					<td>{{syncStatus.applications.different}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>Partners</td>-->
<!--					<td>{{syncStatus.partners.missing}}</td>-->
<!--					<td>{{syncStatus.partners.different}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>Users</td>-->
<!--					<td>{{syncStatus.users.missing}}</td>-->
<!--					<td>{{syncStatus.users.different}}</td>-->
<!--				</tr>-->
<!--			</tbody>-->
<!--		</table>-->
<!--		</div>-->
<!--		<table>-->
<!--			<thead>-->
<!--				<tr>-->
<!--					<th>Setting</th>-->
<!--					<th>Live</th>-->
<!--					<th>Dev</th>-->
<!--				</tr>-->
<!--			</thead>-->
<!--			<tbody>-->
<!--				<tr>-->
<!--					<td>Database</td>-->
<!--					<td>{{config.Settings.Live.DbServer}}<br/>{{config.Settings.Live.Database}}</td>-->
<!--					<td>{{config.Settings.Dev.DbServer}}<br/>{{config.Settings.Dev.Database}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>Queue</td>-->
<!--					<td>{{config.Settings.Live.QueueName}}</td>-->
<!--					<td>{{config.Settings.Dev.QueueName}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>Response Container</td>-->
<!--					<td>{{config.Settings.Live.ResponseContainer}}</td>-->
<!--					<td>{{config.Settings.Dev.ResponseContainer}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>Storage Account</td>-->
<!--					<td>{{config.Settings.Live.StorageAccount}}</td>-->
<!--					<td>{{config.Settings.Dev.StorageAccount}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>Central Storage</td>-->
<!--					<td>{{config.Settings.Live.CentralStorageAccount}}</td>-->
<!--					<td>{{config.Settings.Dev.CentralStorageAccount}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>India Storage</td>-->
<!--					<td>{{config.Settings.Live.IndiaStorage}}</td>-->
<!--					<td>{{config.Settings.Dev.IndiaStorage}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>West US Storage</td>-->
<!--					<td>{{config.Settings.Live.WestUSStorage}}</td>-->
<!--					<td>{{config.Settings.Dev.WestUSStorage}}</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td>Central Config</td>-->
<!--					<td>{{config.Settings.Live.CentralConfig}}</td>-->
<!--					<td>{{config.Settings.Dev.CentralConfig}}</td>-->
<!--				</tr>-->
<!--			</tbody>-->
<!--		</table>-->
	</div>
</template>

<script>
import api from "../api";
import { commitTypes } from "../store-types";

export default {
	data() {
		return {
			syncStatus: null,
		};
	},
	created() {
		api.syncCheck().then((r) => {
			this.syncStatus = r.data;

			this.$store.commit(commitTypes.SET_SYNC_ERROR, !r.data.current);
		}, (e) => {
			this.showError(e);
		});
	},
};
</script>
